import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../config/api';
import { toast } from 'react-toastify';
import { FaTimes, FaTrashAlt, FaSpinner } from 'react-icons/fa';
import './MissedBinModal.css';

const BIN_TYPES = [
  { id: 'general', label: 'General Waste', color: '#333' },
  { id: 'recycling', label: 'Recycling', color: '#2ecc71' },
  { id: 'garden', label: 'Garden Waste', color: '#8B4513' },
  { id: 'food', label: 'Food Waste', color: '#e67e22' }
];

const MissedBinModal = ({ isOpen, onClose }) => {
  const { currentUser } = useAuth();
  const [binType, setBinType] = useState('');
  const [missedDate, setMissedDate] = useState('');
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!binType) {
      toast.error('Please select a bin type');
      return;
    }
    if (!missedDate) {
      toast.error('Please select the date of the missed collection');
      return;
    }

    try {
      setLoading(true);
      await api.reportMissedBin({
        binType,
        missedDate,
        notes: notes.trim() || null
      });
      toast.success('Missed bin collection reported successfully! Your council has been notified.');
      setBinType('');
      setMissedDate('');
      setNotes('');
      onClose();
    } catch (error) {
      console.error('Error reporting missed bin:', error);
      toast.error(error.message || 'Failed to report missed bin collection');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  const today = new Date().toISOString().split('T')[0];
  const twoWeeksAgo = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];

  return (
    <div className="missed-bin-overlay" onClick={onClose}>
      <div className="missed-bin-modal" onClick={e => e.stopPropagation()}>
        <button className="missed-bin-close" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="missed-bin-header">
          <FaTrashAlt className="missed-bin-icon" />
          <h2>Report Missed Bin Collection</h2>
          <p>Let your council know your bin wasn't collected</p>
        </div>

        <form onSubmit={handleSubmit} className="missed-bin-form">
          <div className="missed-bin-field">
            <label>Which bin was missed? *</label>
            <div className="bin-type-grid">
              {BIN_TYPES.map(bin => (
                <button
                  key={bin.id}
                  type="button"
                  className={`bin-type-btn ${binType === bin.id ? 'selected' : ''}`}
                  style={{ '--bin-color': bin.color }}
                  onClick={() => setBinType(bin.id)}
                >
                  <FaTrashAlt />
                  <span>{bin.label}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="missed-bin-field">
            <label htmlFor="missedDate">Date of missed collection *</label>
            <input
              type="date"
              id="missedDate"
              value={missedDate}
              onChange={e => setMissedDate(e.target.value)}
              min={twoWeeksAgo}
              max={today}
            />
          </div>

          <div className="missed-bin-field">
            <label htmlFor="missedNotes">Additional notes (optional)</label>
            <textarea
              id="missedNotes"
              value={notes}
              onChange={e => setNotes(e.target.value)}
              rows="3"
              placeholder="e.g. Bin was out on time, street was blocked, etc."
            />
          </div>

          <button
            type="submit"
            className="missed-bin-submit"
            disabled={loading || !binType || !missedDate}
          >
            {loading ? (
              <><FaSpinner className="spinning" /> Submitting...</>
            ) : (
              'Report Missed Collection'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default MissedBinModal;
